<template>
  <div>
    <van-loading type="spinner" v-if="nodata"/>
    <div style="background: #ffffff;border: 1px solid #DEDEDE;">
      <div class="logo">
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%">
          <span>{{ dominItem.logoName || 'Logo' }}</span>
          <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId" color="#ffffff"></topIcon>
        </div>
      </div>
      <div class="category" >
            <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
                item.label
              }}</span>
      </div>
    </div>


    <div >
      <div class="news-page">
        <div class="news-grid1" >
          <div class="news-item" @click="toDetail(bestItem.articleShortName)">
            <div class="news-image-container">
              <img :src="bestItem.articleImage" class="news-images">
            </div>
            <div class="news-content">
              <h3 class="news-title twoHde" style="margin-left: 0">{{ bestItem.articleTitle }}</h3>
              <p class="news-summary threeHde" style="margin-left: 0">{{ bestItem.articleIntro }}</p>
              <div class="news-meta">
<!--                <span class="news-time">{{ bestItem.uploadTime }}</span>-->
              </div>
            </div>
          </div>
        </div>


        <!-- 第一排三列文章 -->
        <div class="news-grid" >
          <div v-for="(item, index) in articleList" :key="index" class="news-item" @click="toDetail(item.articleShortName)">
            <div class="news-image-container">
              <img :src="item.articleImage" class="news-image">
            </div>
            <div class="news-content">
              <h3 class="news-title twoHde" style="margin-left: 0">{{ item.articleTitle }}</h3>
              <p class="news-summary threeHde" style="margin-left: 0">{{ item.articleIntro }}</p>
              <div class="news-meta">
<!--                <span class="news-time">{{ item.uploadTime }}</span>-->
              </div>
            </div>
          </div>
        </div>

        <div class="news-grid" style="grid-template-columns: repeat(4, 1fr);">
          <div v-for="(item, index) in articleList1" :key="index" class="news-item" @click="toDetail(item.articleShortName)">
            <div class="news-image-container">
              <img :src="item.articleImage" class="news-image">
            </div>
            <div class="news-content">
              <h3 class="news-title twoHde" style="margin-left: 0">{{ item.articleTitle }}</h3>
              <p class="news-summary threeHde" style="margin-left: 0">{{ item.articleIntro }}</p>
              <div class="news-meta">
<!--                <span class="news-time">{{ item.uploadTime }}</span>-->
              </div>
            </div>
          </div>
        </div>

        <div class="analysis-header">
          <h1 class="analysis-title">{{ $t('con_latest') }}</h1>
        </div>

        <!-- 第一排三列文章 -->
        <div class="news-grids" style="grid-template-columns: repeat(2, 1fr);">
          <div v-for="(item, index) in articleList2" :key="index" class="news-item" @click="toDetail(item.articleShortName)">
            <div class="news-image-container">
              <img :src="item.articleImage" class="news-image">
            </div>
            <div class="news-content">
              <h3 class="news-title twoHde" style="margin-left: 0">{{ item.articleTitle }}</h3>
              <p class="news-summary threeHde" style="margin-left: 0">{{ item.articleIntro }}</p>
              <div class="news-meta">
<!--                <span class="news-time">{{ item.uploadTime }}</span>-->
              </div>
            </div>
          </div>
        </div>

        <div class="news-grids" style="grid-template-columns: repeat(5, 1fr);">
          <div v-for="(item, index) in articleList3" :key="index" class="news-item" @click="toDetail(item.articleShortName)">
            <div class="news-image-container">
              <img :src="item.articleImage" class="news-image">
            </div>
            <div class="news-content">
              <h3 class="news-title twoHde" style="margin-left: 0">{{ item.articleTitle }}</h3>
              <p class="news-summary threeHde" style="margin-left: 0">{{ item.articleIntro }}</p>
              <div class="news-meta">
<!--                <span class="news-time">{{ item.uploadTime }}</span>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="buttom">
      <div class="explore">
        <span style="color: #000000">{{ $t('con_Explore') }}</span>
        <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer; color: #000000">{{ item.label }}</span>
      </div>
      <div class="logo" style="color: #000000;">{{ dominItem.logoName || 'Logo' }}</div>
      <footers is00="is00" :articleListlast="articleListlast" :current="current"></footers>
    </div>
  </div>
</template>

<script>
import {getOne, newContent} from "@/api"
import topIcon from '../../icons/iconblick.vue'
import {format} from "date-fns";
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"

export default {
  components: {topIcon, buttomIcon, footers},


  props: {
    dominItem: Object
  },

  name: "index",
  data() {
    return {
      bestItem: {},
      nodata: false,
      // template: 'temp3',
      current: 1,
      recommendList: [],
      latestNewsList: [],
      articleList: [],
      articleList1: [],
      articleList2: [],
      articleList3: [],
      articleList4: [],
      articleListlast: [],
      recommendList1: [],
      typeList: [
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_home'), id: 1},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_LIFESTYLE'), id: 5},
      ],
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
    }
  },
  created() {
    this.nationId = JSON.parse(localStorage.getItem('dominItem')).nationId


    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    } else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    }
  },

  methods: {
    openLink(link) {
      window.open(link)
    },
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    },

    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },


    // 获取推荐文章列表
    getArticleList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 6,
        articleNationId: this.nationId,
        articleType: 'con_recommended'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows
        this.nodata = false
      })
    },


    // 获取最新文章
    getLatestNewsList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 12,
        articleNationId: this.nationId,
        articleType: 'con_latest'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList1 = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取热门文章
    getRecommendList() {
      newContent({
        articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 4,

        articleNationId: this.nationId, articleType: 'con_hot_con'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList2 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList1() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 10,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList3 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList2() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 9,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList4 = res.rows
      })
    },

    // 获取最下面文章列表  相关文章
    getArticleListlast() {
      // this.nodata = true
      newContent({
        articleCategoryId: this.current,
        pageNum: 3,
        pageSize: 6,
        articleNationId: this.nationId,
        articleType: 'con_related'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
.news-page {
  padding: 20px 0;

.analysis-header {
  padding: 0px 15% 10px;
  //border-bottom: 1px solid #E6E8EA;
  margin-bottom: 10px;
}

.analysis-title {
  font-size: 28px;
  font-weight: bold;
  color: #333333;
  margin: 0;
  padding: 0;
}

  .news-grid1{
    display: grid;
    padding: 0 15%;
    grid-template-columns: repeat(1, 1fr);
    gap: 30px;
    margin-bottom: 40px;
  }

.news-grid {
  display: grid;
  padding: 0 15%;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-bottom: 40px;
}

  .news-grids {
    display: grid;
    padding: 0 15%;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    margin-bottom: 40px;
  }

.news-item {
  cursor: pointer;
  border-bottom: 1px solid #E6E8EA;
  padding-bottom: 10px;
  transition: transform 0.2s ease;
}

.news-item:hover {
  transform: translateY(-5px);
}

.news-image-container {
  margin-bottom: 15px;
  overflow: hidden;
}

.news-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: transform 0.3s ease;
}

  .news-images {
    width: 100%;
    height: 500px;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

.news-item:hover .news-image {
  transform: scale(1.05);
}

.news-category {
  display: inline-block;
  background-color: #E2001A;
  color: white;
  padding: 3px 8px;
  font-size: 12px;
  margin-bottom: 10px;
}

.news-title {
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 10px 0;
  color: #333333;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-summary {
  font-size: 14px;
  color: #666666;
  margin: 0 0 10px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-meta {
  font-size: 12px;
  color: #999999;
}

.but-box {
  padding: 30px 0;
  border-top: 1px solid #E6E8EA;
}
}

.but-box {
}


.logo {
  width: 85%;
  margin-left: 15%;
  padding: 10px 0;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  font-size: 20px;
  color: #001655;
  justify-content: space-between;
  font-weight: bold;
  text-align: left;
}

.logo-temp1 {
  padding: 0 20px 0 15%;
}

.logo-temp2 {
}

.category {
  width: 70%;
  margin: 0 auto;
  min-height: 40px;
  //margin-bottom: 30px;
  color: #013497;
  font-weight: 700;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid #E6E8EA;
  line-height: 38px;

  span {
    font-weight: 500;
    font-size: 17px;
    display: inline-block;
    padding: 0 10px;
    cursor: pointer;
    position: relative;
    border-bottom: 3px solid #ffffff;
  }

  span:hover {
    color: #000000;
    border-bottom: 3px solid red;
    transition: all .1s ease;
  }

  .choose {
    transition: all .1s ease;
    color: red;
    //border-bottom: 3px solid #000000;
  }
}

.buttom {
  background: #ffffff;
  border-top: 2px solid #000000;
  display: flex;
  flex-direction: column;

  .logo {
    width: 80%;
    margin:  auto;
    font-size: 20px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
  }

  display: flex;

  .explore {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    align-items: center;

    span:first-child {
      color: #004F8B;
      font-size: 18px;
      font-weight: bold;
      margin-right: 30px;
    }

    span {
      margin-right: 10px;
      font-size: 15px;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #000000;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  display: flex;
  flex-wrap: wrap;

  span {
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.imgsss {
  width: 30px;
  height: 30px;
}

.imgsss:nth-child(4) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(5) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(3) {
  width: 40px;
  height: 40px;
}

.article-image1 {
  width: 80px;
  height: 80px;
  object-fit: cover;
}
.bgSpan {
  color: #ffffff;
  border-radius: 5px;
  border: 1px solid red;
  display: inline-block;
  padding: 5px 10px;
  background: #E2001A;
}

</style>